if (!customElements.get('header-search-popdown')) {
  customElements.define(
    'header-search-popdown',

    class SearchPopdown extends HTMLElement {
      constructor() {
        super();
        this.popdown = this.querySelector('[data-popdown]');
        this.popdownContainer = this.querySelector('[data-popdown-container]');
        this.popdownClose = this.querySelector('[data-popdown-close]');
        this.popdownOpen = this.querySelector('[data-popdown-open]');
        this.popdownTransitionCallback = this.popdownTransitionCallback.bind(this);
        this.a11y = window.theme.a11y;
      }

      connectedCallback() {
        this.popdown.addEventListener('transitionend', this.popdownTransitionCallback);
        this.popdownContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
        this.popdownOpen.addEventListener('click', this.open.bind(this));
        this.popdownClose.addEventListener('click', this.close.bind(this));

        screen.orientation.addEventListener("change", this.close.bind(this));
      }

      popdownTransitionCallback(event) {
        const isValidTransition = event.propertyName === 'opacity';
        if (event.target !== this.popdown || !isValidTransition) return;

        if (!this.classList.contains('is-open')) {
          this.popdownContainer.removeAttribute('open');
          this.a11y.removeTrapFocus();
        } else {
          // Wait for the 'transform' transition to complete in order to prevent jumping content issues because of the trapFocus
          this.a11y.trapFocus(this.popdown, {
            elementToFocus: this.popdown.querySelector('input:not([type="hidden"])'),
          });
        }
      }

      onBodyClick(event) {
        if (!this.contains(event.target) || event.target.hasAttribute('data-popdown-underlay')) this.close();
      }

      open() {
        this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);

        document.body.addEventListener('click', this.onBodyClickEvent);

        if (!document.documentElement.hasAttribute('data-scroll-locked')) {
          document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true}));
        }

        requestAnimationFrame(() => {
          this.classList.add('is-open');
        });
      }

      close() {
        this.classList.remove('is-open');

        document.body.removeEventListener('click', this.onBodyClickEvent);
        document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
      }
    }
  );
}
